import React, { useState, Component, useContext } from 'react';
import { Link } from '@reach/router';
import UserContext from '../providers/UserProvider';
import { dataService } from '../dataService';
import { Table, Layout, Row, Col, Tooltip, Spin, Switch, Avatar } from 'antd';
const { Header, Content, Footer } = Layout;

const getUsers = async () => {
    const snapshot = await dataService.firestore.collection('users').get();
    return snapshot.map((doc) => {
        let item = doc.data();
        return item;
    });
};

const getSwitch = (value, item, onChange) => {
    const context = useContext(UserContext);
    let disabled = false;
    return (
        <Switch
            disabled={disabled}
            defaultChecked={value}
            onChange={() => {
                onChange(item);
            }}
        />
    );
};

const onActiveChange = async (item) => {
    item.active = !item.active;
    await dataService.firestore.collection('users').doc(item.id).set(item);
};

const onAdminChange = async (item) => {
    item.admin = !item.admin;
    await dataService.firestore.collection('users').doc(item.id).set(item);
};

const columns = [
    {
        title: 'Name',
        dataIndex: 'displayName',
        render: (active, item) => (
            <span>
                <Avatar src={item.photoURL} />
                <span style={{ paddingLeft: 10 }}>{item.displayName}</span>
            </span>
        )
    },
    {
        title: 'Email',
        dataIndex: 'email'
    },
    {
        title: 'Active',
        dataIndex: 'active',
        render: (active, item) => getSwitch(active, item, onActiveChange)
    },
    {
        title: 'Admin',
        dataIndex: 'admin',
        render: (admin, item) => getSwitch(admin, item, onAdminChange)
    }
];

class Admin extends Component {
    state = {
        users: [],
        isLoading: false
    };

    render() {
        const { users, isLoading } = this.state;
        return (
            <Layout>
                <Header style={{ position: 'fixed', zIndex: 1, width: '100%' }}>
                    <Link to="/">Back</Link>
                </Header>
                <Content style={{ padding: '0 50px', marginTop: 64 }}>
                    <div className="site-layout-content">
                        <Spin spinning={isLoading}>
                            <Table
                                columns={columns}
                                dataSource={users}
                                pagination={false}
                            />
                        </Spin>
                    </div>
                </Content>
                <Footer style={{ textAlign: 'center' }}>SpareDox</Footer>
            </Layout>
        );
    }

    componentDidMount() {
        this.setState({ isLoading: true });
        getUsers().then((result) => {
            this.setState({ users: result, isLoading: false });
        });
    }
}

export default Admin;



// WEBPACK FOOTER //
// ./demo/src/components/Admin.js